import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faLocationDot } from "@fortawesome/free-solid-svg-icons";
const CardDonneurOrdre = ({ donneurOrdre }) => {
    const apiUrl = process.env.REACT_APP_API_URL;

    return (
        <div className="card-prestaV2">
                
                <div className="logo-presta">

                    <img src={donneurOrdre.logo?apiUrl +
                                            "/api/files/?categorie=logos&file=" +
                                            donneurOrdre?.logo:`${apiUrl}/api/files/?categorie=secteurs&file=${donneurOrdre.secteur.iconSecteur}`} alt="logo ou icone secteur" />

                </div>


            <div className="inner-card">
                <div>
                    <h3 style={{color:"blue"}}><FontAwesomeIcon icon={faLocationDot} style={{marginRight:"15px"}} />{donneurOrdre.ville}</h3>
                <h3>{donneurOrdre.raisonSocialeEntreprise}</h3>
                </div>
                <div className="separator">

                </div>
                {/* <div>
                    <p className="infos-presta">
                        <span className="presta-name">{prestataire.firstNamePrestataire}</span>
                        
                       
                    </p>
          
                </div> */}
                

                {donneurOrdre.siretEntreprise && (
                        <a
                            href={`https://www.societe.com/cgi-bin/search?champs=${donneurOrdre.siretEntreprise}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="siret-button"
                        >
                            🔍 Vérifier le SIRET
                        </a>

                    )}

            </div>

        </div>
    )
}
export default CardDonneurOrdre;